import { LineasAsientosContablesByFilterDtoIProps } from "api/DTOs/LineasAsientosContablesByFilterDto"

import { TIPO_LINEA_ASIENTO } from "api/Types/TipoLineaAsiento"
import { NeutralNumber } from "features/Contabilidad/components/NeutralNumber"
import { TFunction } from "i18next"
import { frontendDateFormat } from "utils/formatDate"
import { TIPOS_ASIENTOS } from "../../LibroMayor/constants/TiposAsientos"
import { DocumentoAsociadoAsiento } from "../../LibroMayor/constants/columnsTemplates"
import { NombreCuentaContableAsiento } from "./columnsTemplates"

export const LIBRO_DIARIO_COLUMNS = (
  t: TFunction,
  handleOpenDocumentoModal: (id: string) => void,
  headerTemplate: () => JSX.Element
) => {
  const columns = [
    {
      header: t("diario.tab.headerEntry"),
      field: "asientoContable.numero",
      key: "asientoContable.numero",
      style: { width: "5%" },
      sortable: true,
      sortField: "asientoContable.numero",
      isFixedColumn: true,
    },
    {
      header: t("diario.tab.headerLine"),
      field: "numero",
      key: "numero",
      style: { width: "3%" },
      sortable: true,
      sortField: "numero",
      isFixedColumn: false,
    },
    {
      header: t("diario.tab.headerDate"),
      field: "asientoContable.fecha",
      key: "asientoContable.fecha",
      style: { width: "5%" },
      sortable: true,
      sortField: "asientoContable.fecha",
      isFixedColumn: true,
      body: ({ asientoContable }: LineasAsientosContablesByFilterDtoIProps) => {
        return asientoContable?.fecha
          ? frontendDateFormat(new Date(asientoContable.fecha))
          : ""
      },
    },
    {
      header: t("diario.tab.headerCreationUser"),
      field: "asientoContable.creationUser.nombre",
      key: "asientoContable.creationUser.nombre",
      sortable: false,
      isFixedColumn: false,
      body: ({ asientoContable }: LineasAsientosContablesByFilterDtoIProps) => {
        return asientoContable?.creationUser
          ? asientoContable.creationUser.nombre
          : "-"
      },
      style: { width: "5%" },
    },
    {
      header: t("diario.tab.headerCreationTime"),
      field: "asientoContable.creationTime",
      key: "asientoContable.creationTime",
      sortable: false,
      isFixedColumn: false,
      body: ({ asientoContable }: LineasAsientosContablesByFilterDtoIProps) => {
        return asientoContable?.creationTime
          ? frontendDateFormat(new Date(asientoContable.creationTime))
          : ""
      },
      style: { width: "5%" },
    },
    {
      header: t("diario.tab.headerType"),
      field: "asientoContable.tipo",
      key: "asientoContable.tipo",
      style: { width: "7%" },
      sortable: true,
      sortField: "asientoContable.tipoAsiento",
      isFixedColumn: false,
      body: (rowData: LineasAsientosContablesByFilterDtoIProps) =>
        TIPOS_ASIENTOS(t).find(
          ({ tipo }) => rowData?.asientoContable?.tipo === tipo
        )?.descripcion,
    },
    {
      header: t("diario.tab.headerDescription"),
      field: "descripcion",
      key: "descripcion",
      style: { width: "17%" },
      sortable: true,
      sortField: "descripcion",
      isFixedColumn: false,
    },
    {
      header: t("diario.tab.headerDoc"),
      field: "numeroDocumento",
      key: "numeroDocumento",
      style: { width: "9%" },
      sortable: true,
      sortField: "numeroDocumento",
      isFixedColumn: false,
      body: (rowData: LineasAsientosContablesByFilterDtoIProps) =>
        DocumentoAsociadoAsiento({ handleOpenDocumentoModal, rowData }),
    },
    {
      header: t("diario.tab.headerAccount"),
      field: "cuentaContable.numero",
      key: "cuentaContable.numero",
      style: { width: "8%" },
      sortable: false,
      sortField: "numeroCuentaContable",
      isFixedColumn: true,
      body: (rowData: LineasAsientosContablesByFilterDtoIProps) =>
        NombreCuentaContableAsiento(rowData),
    },
    {
      header: t("diario.tab.headerName"),
      field: "cuentaContable.nombre",
      key: "cuentaContable.nombre",
      style: { width: "17%" },
      isFixedColumn: false,
    },
    {
      header: t("diario.tab.headerDebit"),
      field: "debe",
      key: "debe",
      style: { width: "6%" },
      className: "!tw-text-end",
      alignCol: "right",
      isFixedColumn: true,
      body: (rowData: LineasAsientosContablesByFilterDtoIProps) => {
        const debe =
          rowData?.tipo === TIPO_LINEA_ASIENTO.DEBE ? rowData?.importe ?? 0 : 0
        return NeutralNumber(debe)
      },
    },
    {
      header: t("diario.tab.headerHaber"),
      field: "haber",
      key: "haber",
      style: { width: "6%" },
      className: "!tw-text-end",
      alignCol: "right",
      isFixedColumn: true,
      body: (rowData: LineasAsientosContablesByFilterDtoIProps) => {
        const haber =
          rowData?.tipo === TIPO_LINEA_ASIENTO.HABER ? rowData?.importe ?? 0 : 0
        return NeutralNumber(haber)
      },
    },
    {
      field: "actions",
      alignCol: "right",
      style: { width: "1%", minWidth: "1%", maxWidth: "1%", padding: "8px" },
      isFixedColumn: true,
      header: () => headerTemplate(),
    },
  ]

  return columns
}
